/* fonts */
export const FontFamily = {
  labelMedium: 'Roboto_Medium',
  labelRegular: 'Roboto_Regular',
  labelBold: 'Roboto_Bold',
};
/* font sizes */
export const FontSize = {
  labelMedium_size: 14,
  p_size: 15,
  size_2xs: 11,
  size_smi: 13,
  smallCapRegular_size: 12,
  h4_size: 22,
  h5_size: 16,
  size_25xl: 44,
  h3_size: 30,
  size_3xs: 10,
};
/* Colors */
export const Color = {
  blanc: '#fff',
  VertElectrique: '#678aae',
  MainNoir: '#302a25',
  MainGris: '#979592',
  colorGray_100: '#E8E8EE',
  sideOverlayBg: 'rgba(48, 42, 37, 0.4)',
  colorGray_150: 'rgba(48, 42, 37, 0.5)',
  sideOverlayBgDarker: 'rgba(48, 42, 37, 0.7)',
  colorGray_200: 'rgba(0, 0, 0, 0.1)',
  black: '#000',
  error: '#b3261e',
  sECVERMEIL: '#ff5757',
  MainBleu: '#2f5b8e',
  LightMainBleu: '#e9eaf5',
  sECJAUNE: '#E6B22B',
  sECCIEL: '#2dc0ff',
  blueviolet: '#ac46ff',
  BlancCasse: '#f1f3fe',
  royalblue: '#127af4',
  gainsboro: '#d9d9d9',
  darkslategray: '#434343',
  LevelGood: '#328300',
  LevelMid: '#ff7a00',
  LevelBad: '#890000',
  LevelNA: '#797979',
};
/* Paddings */
export const Padding = {
  p_91xl: 110,
  p_11xl: 30,
  p_11xs: 2,
  p_6xl: 25,
  p_mid: 17,
  p_xs: 12,
  p_lg: 18,
  p_3xs: 10,
  p_7xs: 6,
  p_8xs: 5,
  p_9xs: 4,
  p_13xl: 32,
  p_smi: 13,
  p_xl: 20,
  p_mini: 15,
  p_10xs: 3,
  p_21xl: 40,
  p_sm: 14,
  p_5xs: 8,
  p_38xl: 57,
  p_36xl: 55,
  p_41xl: 60,
  p_31xl: 50,
  p_101xl: 120,
};
/* border radiuses */
export const Border = {
  br_5xl: 24,
  br_xs: 12,
  br_sm: 14,
  br_4xs: 9,
  br_3xs: 10,
  br_3xl: 22,
  br_8xs: 5,
  br_11xs: 2,
  br_24xl: 43,
  br_11xl: 30,
  br_31xl: 50,
  br_10xs: 3,
  br_9xs: 4,
};

export const Breakpoints = {
  mobile: 510,
  tablet: 768,
  desktop: 1024,
  lgDesktop: 1280,
};
